"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var MultiSelectionProvider = /** @class */ (function (_super) {
    __extends(MultiSelectionProvider, _super);
    function MultiSelectionProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.setSelectedKeys = function (selectedKeys) {
            _this.setState({ selectedKeys: selectedKeys });
        };
        _this.updateSelectionForKey = function (key) {
            _this.setState(function (prevState) {
                var newKeys = __assign({}, prevState.selectedKeys);
                if (prevState.selectedKeys[key]) {
                    delete newKeys[key];
                }
                else {
                    newKeys[key] = true;
                }
                return { selectedKeys: newKeys };
            });
        };
        _this.clearSelection = function () {
            _this.setState({ selectedKeys: {} });
        };
        _this.state = { selectedKeys: {} };
        return _this;
    }
    MultiSelectionProvider.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.selectionId !== prevProps.selectionId) {
            this.setState({ selectedKeys: {} });
        }
    };
    MultiSelectionProvider.prototype.render = function () {
        return this.props.children({
            selectedKeys: this.state.selectedKeys,
            setSelectedKeys: this.setSelectedKeys,
            updateSelectionForKey: this.updateSelectionForKey,
            clearSelection: this.clearSelection
        });
    };
    return MultiSelectionProvider;
}(React.Component));
exports.MultiSelectionProvider = MultiSelectionProvider;
var SingleSelectionProvider = /** @class */ (function (_super) {
    __extends(SingleSelectionProvider, _super);
    function SingleSelectionProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.updateSelectionForKey = function (key) {
            _this.setState(function (prevState) {
                var _a;
                var newKey = prevState.selectedKeys[key] ? {} : (_a = {}, _a[key] = true, _a);
                return { selectedKeys: newKey };
            });
        };
        _this.clearSelection = function () {
            _this.setState({ selectedKeys: {} });
        };
        _this.state = { selectedKeys: {} };
        return _this;
    }
    SingleSelectionProvider.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.selectionId !== prevProps.selectionId) {
            this.setState({ selectedKeys: {} });
        }
    };
    SingleSelectionProvider.prototype.render = function () {
        return this.props.children({
            selectedKeys: this.state.selectedKeys,
            updateSelectionForKey: this.updateSelectionForKey,
            clearSelection: this.clearSelection
        });
    };
    return SingleSelectionProvider;
}(React.Component));
exports.SingleSelectionProvider = SingleSelectionProvider;
//# sourceMappingURL=SelectionProvider.js.map